(function () {
  'use strict';

  angular
      .module('tfc.retailer.CollapsibleBox',[]);

})();